export interface EmittedPayload {
  data: any;
  action: TableAction;
}

export enum TableAction {
  edit = 'edit',
  delete = 'delete',
  deleteArchive = 'deleteArchive',
  archive = 'archive',
  unarchive = 'unarchive',
  view = 'view',
  mobileMenu = 'mobileMenu',
  sort = 'sort',
  copyLink = 'copyLink',
  welcomeEmail = 'welcomeEmail',
  duplicate = 'duplicate',
  select = 'select',
  deselect = 'deselect',
  changeOrder = 'changeOrder',
  download = 'download',
  changeVisibility = 'changeVisibility',
  dropdownChanged = 'dropdownChanged',
  replyToMessage = 'replyToMessage',
  sendMessage = 'sendMessage',
  sync = 'sync'
}

export interface TableEntryValue {
  value: unknown;
  // The below provides ability to append an icon to a text in the table cell - either before of after the text
  icon?: { src: string; position: 'start' | 'end' };
}

export interface TableOption {
  action: string;
  src: string;
  tooltip?: string;
  // TODO - these are intended to serve as a source of truth for the mobile menu in tables
  // Need to review and see if we can utilize it - as currently it is not in use
  menuItems?: any[];
}

export interface TableEntry {
  [key: string]: TableEntryValue;
}

export interface TableSource {
  displayedColumns: string[];
  displayedTitles: string[];
  displayedTooltips: string[];
  columnsConfig: { [key: string]: unknown }[];
  options: TableOption[];
  optionsPerRow?: TableOption[][];
  dataSource: TableEntry[];
  restrictedAccessActions?: { [key: string]: string[] };
  columnsWithTitle?: string[];
}
